import axios from 'axios'
import { deviceUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 查询管控柜
export function devicecabinetPage(params) {
  const url = deviceUrl + '/device/cabinet/page'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '查询管控柜', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除管控柜信息
export function deleteCabinet(params) {
  const url = deviceUrl + '/device/cabinet/delete?id=' + params.id
  return axios({
    method: 'delete',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '删除管控柜信息', res)
    }
    return Promise.resolve(res.data)
  })
}
// 管控柜存在则更新，否则新增
export function savecabinet(params) {
  const url = deviceUrl + '/device/cabinet'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '新增管控柜', res)
    }
    return Promise.resolve(res.data)
  })
}
// 授权用户树
export function devicecabinetUser(params) {
  const url = deviceUrl + '/device/cabinet/user/tree'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '授权用户树', res)
    }
    return Promise.resolve(res.data)
  })
}
// <-- 监控中心=》管控柜页面接口 -->
// 机构管控柜关系树
export function devicecabinetTree(params) {
  const url = deviceUrl + '/device/cabinet/tree'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('监控中心', '机构管控柜关系树', res)
    }
    return Promise.resolve(res.data)
  })
}

// 监控中心分页查询管控柜
export function devicecabinetFind(params) {
  const url = deviceUrl + '/device/cabinet/find'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('监控中心', '机构管控柜关系树', res)
    }
    return Promise.resolve(res.data)
  })
}
// 监控中心管控柜数据统计
export function cabinetStatistics(params) {
  const url = deviceUrl + '/device/cabinet/statistics'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('监控中心', '管控柜数据统计', res)
    }
    return Promise.resolve(res.data)
  })
}
// 监控中心管控柜=>仓格统计
export function cabinetCellStatistics(params) {
  const url = deviceUrl + '/device/cabinet/cell/statistics'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('监控中心', '管控柜数据统计', res)
    }
    return Promise.resolve(res.data)
  })
}
// 监控中心管控柜=>仓格分页查询
export function cabinetCellPage(params) {
  const url = deviceUrl + '/device/cabinet/cell/page'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('监控中心', '管控柜仓格分页查询', res)
    }
    return Promise.resolve(res.data)
  })
}
// 监控中心管控柜=>查询仓格插座充电状态
export function cabinetCellCharge(params) {
  const url = deviceUrl + '/device/cabinet/cell/charge'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('监控中心', '查询仓格插座充电状态', res)
    }
    return Promise.resolve(res.data)
  })
}
// 监控中心管控柜=>分页查询仓格开关门记录
export function cabinetCellOperation(params) {
  const url = deviceUrl + '/device/cabinet/cell/operation/page'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('监控中心', '分页查询仓格开关门记录', res)
    }
    return Promise.resolve(res.data)
  })
}